import { client } from '../..'
import { CHANGE_NAME_DISPLAY_PREFERENCE } from './Mutations'
import { ChangeNameDisplayPreferenceMutation, ChangeNameDisplayPreferenceMutationVariables } from '../../types'
import { NameDisplayPreference } from '../../graphql/enum/name-display-preference.enum'
import { FetchResult, MaybeMasked } from '@apollo/client'

export const changeNameDisplayPreference = async (
  employeeId: number,
  nameDisplayPreference: NameDisplayPreference,
): Promise<FetchResult<MaybeMasked<ChangeNameDisplayPreferenceMutation>>> => {
  return client.mutate<ChangeNameDisplayPreferenceMutation, ChangeNameDisplayPreferenceMutationVariables>({
    mutation: CHANGE_NAME_DISPLAY_PREFERENCE,
    variables: { employeeId, nameDisplayPreference },
  })
}
